<template>
  <div class="white-card blog-card" @click="toDetail(blog.blogId)">
    <div class="title">
      <h3>{{ blog.title }}</h3>
      <span class="type" :class="getTypeClass(blog.type)">{{
        typeMap[blog.type]
      }}</span>
    </div>
    <section
      style="margin-top: 8px"
      v-text="$options.filters.ellipsis(blog.content)"
    ></section>
    <div class="label" v-if="blog.label">
      <template>
        <span v-for="item in blog.label.split(',')">
          {{ item }}
        </span>
      </template>
    </div>
    <div class="statistics">
      <div class="block">
        <img src="@/assets/images/icon/eye.png" alt="" />
        <span> {{ blog.readingCount || 0 }}</span>
      </div>
      <div class="block">
        <img src="@/assets/images/icon/pinglun.png" alt="" />
        <span>{{ blog.commentCount || 0 }}</span>
      </div>
      <div class="block">
        <img src="@/assets/images/icon/like.png" alt="" />
        <span>
          {{ blog.likeCount || 0 }}
        </span>
      </div>
      <div class="block">
        <img src="@/assets/images/icon/clock.png" alt="" />
        <span>{{ blog.createTime }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "blogCard",
  props: {
    blog: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      typeMap: {
        0: "原创",
        1: "转载",
        2: "翻译",
      },
    };
  },
  filters: {
    ellipsis(val) {
      if (val.length <= 50) return val;
      return val.slice(0, 50) + "...";
    },
  },
  methods: {
    toDetail(id) {
      this.$router.push({
        path: "/detail",
        query: {
          blogId: id,
        },
      });
    },

    getTypeClass(type) {
      let className = "";
      switch (type) {
        case "0":
          className = "blue";
          break;
        case "1":
          className = "green";
          break;
        case "2":
          className = "yellow";
          break;
      }
      return className;
    },
  },
};
</script>
<style scoped>
.iconfont {
  font-size: 12px;
}
.icon {
  padding: 0 5px;
}

.blog-card {
  padding: 20px;
}
.iconfont {
  font-size: 12px;
  color: var(--primary-color);
}
.title {
  display: flex;
  position: relative;
}
.title h3 {
  width: auto;
  max-width: calc(100% - 55px);
  overflow: hidden;
  text-overflow: ellipsis;
  letter-spacing: 1px;
}

/* 类型 */
.type {
  position: absolute;
  padding: 2px 10px;
  font-size: 14px;
  margin-left: 5px;
  right: 0;
  border-radius: 4px;
}
.blue {
  border: 1px solid var(--primary-color);
  color: var(--primary-color);
}
.green {
  border: 1px solid var(--green-color);
  color: var(--green-color);
}

/* 标签 */
.label {
  margin-top: 20px;
}
.label span {
  display: inline-block;
  line-height: 1;
  margin-right: 15px;
  padding: 7px 12px;
  /* background: var(--primary-color); */
  background: #5498cb;
  border-radius: 20px;
  font-size: 14px;
  color: #fff;
}

/* 数据统计 */
.statistics {
  width: 100%;
  display: flex;
  flex-direction: row;
  padding-top: 15px;
  margin-top: 15px;
  border-top: 1px solid #f6f6f6;
}
.block {
  padding-right: 5px;
  display: flex;
  align-items: center;
}
.block img {
  width: 16px;
  height: 16px;
  vertical-align: middle;
  border: 0;
}
.block span {
  font-size: 12px;
  color: #aaa;
  margin-left: 4px;
}
.block:last-child {
  flex: 1;
  justify-content: flex-end;
}
</style>

